// extracted by mini-css-extract-plugin
module.exports = {"root":"c7kqI7L","title":"c9z7N-T","titleSponsored":"X67wW7","slider":"yl5L5Q"};